// src/index.js (or src/main.jsx)

import React from 'react'; // Import React
import ReactDOM from 'react-dom/client'; // Import ReactDOM client for React 18
import App from './App'; // Import your main App component
import './index.css'; // Import your global CSS (optional)
import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';
import Header from './components/Header/Header';
import Learning_22_05_2025 from './components/Learning_22_05_2025/Learning_22_05_2025'
import Learning_23_05_2025 from './components/Learning_23_05_2025/Learning_23_05_2025'
import Learning_24_05_2025 from './components/learning_24_05_2025/_24_05_2025'
import Learning_25_05_2025 from './components/learning_25_05_2025/learning_25_05_2025'
import Learning_26_05_2025 from './components/learning_26_05_2025/learning_26_05_2025'
import Learning_27_05_2025 from './components/learning_27_05_2025/learning_27_05_2025'
import Learning_29_05_2025 from './components/learning_29_05_2025/learning_29_05_2025'
import Learning_30_05_2025 from './components/learning_30_05_2025/learning_30_05_2025'


// Create a very simple test component
const TestComponent = () => <h2>Test Component Rendered!</h2>;


// Get the root DOM element where your React app will be mounted
const rootElement = document.getElementById('root');

// Create a React root
const root = ReactDOM.createRoot(rootElement);

// Render your App component into the root, wrapped with BrowserRouter
root.render(
  <React.StrictMode>
    {/*
      BrowserRouter makes the routing context available to all components
      within your <App /> tree.
      It uses the HTML5 history API (pushState, replaceState, and the popstate event)
      to keep your UI in sync with the URL.
    */}
    <BrowserRouter>
      <App />
      <Routes>
        <Route path='/header' element={<Header/>}/>
        <Route path='/learning_20250522' element={<Learning_22_05_2025/>}/>
        <Route path='/learning_20250523' element={<Learning_23_05_2025/>}/>
        <Route path='/learning_20250524' element={<Learning_24_05_2025/>}/>
        <Route path='/learning_20250525' element={<Learning_25_05_2025/>}/>
        <Route path='/learning_20250526' element={<Learning_26_05_2025/>}/>
        <Route path='/learning_20250527' element={<Learning_27_05_2025/>}/>
        <Route path='/learning_20250529' element={<Learning_29_05_2025/>}/>
        <Route path='/learning_20250530' element={<Learning_30_05_2025/>}/>
        <Route path='/test' element={<TestComponent/>}/> 
        <Route path='/' element={<div><h2>Welcome Home!</h2></div>}></Route>
        <Route
        path="*"
        element={<Navigate to="/" replace />}
    />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);